export default "__VITE_ASSET__D156xc8T__"